import { useState, useEffect } from 'react';
import LogSummary from './LogSummary';
import Report from './Report';
import Treatments from './Treatments';
import Medications from './Medications';
import { useAuthContext } from '../hooks/useAuth';

const Patient = ({ ptNumber }) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [patient, setPatient] = useState();
  const { token } = useAuthContext();

  console.log('Patient:top:patient_number:' + ptNumber);

  useEffect(() => {
    console.log('Patient:useEffect:', ptNumber);
    fetch('/hadi/find_patient', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: token },
      body: JSON.stringify({ patient_number: ptNumber }),
    })
      .then(async (response) => {
        const result = await response.json();
        if (!response.ok) {
          const error = (result && result.message) || response.status;
          return Promise.reject(error);
        }
        console.log('Patient:fetch:result:', result);
        setIsLoaded(true);
        setPatient(result);
      })
      .catch((error) => {
        setIsLoaded(true);
        setError(error);
      });
  }, [ptNumber]);

  console.log('Patient:render:patient_number:' + ptNumber);
  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!patient) {
    return <div>Loading...</div>;
  } else {
    return (
      <div className="jumbotron">
        <h3>Patient Number: {ptNumber}</h3>
        <div className="card-columns">
          <LogSummary summary={patient} />
          <Report link={patient.link} />
          <Treatments treatments={patient['treatments']} />
          <Medications medications={patient['medications']} />
        </div>
      </div>
    );
  }
};

export default Patient;
